import React, { useEffect, useState } from "react";
import MapViewScreen from "../MapViewScreen/MapViewScreen";
import LeadFinderScreen from "../LeadFinderScreen/LeadFinderScreen";
import {
    UpdatePayment_LeadFinder,
    UpdatePayment_MapView,
    VerifyPaymemt_LeadFinder,
    VerifyPaymemt_MapView,
} from "../../utils/apicall";


export const Home = () => {
    const [productType, setProductType] = useState(null);
    const [email, setUserEmail] = useState("");
    const [status, setStatus] = useState("");
    const [addonID, setAddonID] = useState("");
    const [orgID, setOrgID] = useState("");
    const [checkPayments_Stripe, setCheckPayments_Stripe] = useState(null);
    const [enviornment, setEnviornment] = useState(null);


    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        setProductType(searchParams.get("ProductType")?.toLowerCase());
        setUserEmail(searchParams.get("User_Email"));
        setStatus(searchParams.get("Status"));
        setAddonID(searchParams.get("AddOnID"));
        setOrgID(searchParams.get("Org_ID"));
        setCheckPayments_Stripe(searchParams.get("Payments_Stripe"));
        setEnviornment(searchParams.get("Environment"))
    }, []);

    const handle_VerifyAddOn = async (type) => {
        const payload = {
            userEmail: email,
            Status: status,
            AddOnID: addonID,
            Org_ID: orgID,
            Environment: enviornment
        };

        try {
            let response;
            if (type === "mapview") {
                response = await VerifyPaymemt_MapView(payload);
            } else if (type === "leadfinder") {
                response = await VerifyPaymemt_LeadFinder(payload);
            }
            // console.log("response", response);
        } catch (error) {
            console.log("Error", error);
        }
    };

    useEffect(() => {

        if (email && status && addonID && orgID && productType && enviornment) {
            handle_VerifyAddOn(productType);
        }
    }, [email, status, addonID, orgID, productType, enviornment]);

    return (
        <>
            {productType === "mapview" && (
                <MapViewScreen checkPayments_Stripe={checkPayments_Stripe} />
            )}

            {productType === "leadfinder" && (
                <LeadFinderScreen checkPayments_Stripe={checkPayments_Stripe} />
            )}
        </>
    );
};

